module.exports = __webpack_public_path__ + "static/media/about-bar.5bfd6481.png";